// Function to inject raw script content
function injectRawScript(scriptContent: string, id: string, target: string) {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.id = id;
  script.defer = true;

  // Remove any surrounding <script> tags for safety
  script.textContent = scriptContent.replace(/<\/?script>/g, "");
  const targetElement = document.getElementById(target);
  if (targetElement) targetElement.append(script);
  return script;
}

// Function to parse script content with multiple scripts and a noscript block
export function parseScriptContent(
  scriptData: string,
  id: string,
  target: string,
) {
  const scriptRegex = /<script[^>]*>([\s\S]*?)<\/script>/gi;

  let match;
  let index = 0;
  // Inject all the script tags
  while ((match = scriptRegex.exec(scriptData)) !== null) {
    const scriptId = `${id}-script-${index}`;
    injectRawScript(match[1], scriptId, target);
    index++;
  }
}

export function containsScriptTag(input: string): boolean {
  const scriptTagRegex = /<script[^>]*>([\s\S]*?)<\/script>/gi;
  return scriptTagRegex.test(input);
}
